// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"83fc5707","112":"8c700b17","263":"4b342cc1","367":"1984ace0","594":"f7291594","688":"d3b059b5","981":"8357947a"}[chunkId] + ".chunk.js";
};